(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alt-rich-text"] && !Shopify.designMode) return;
  try {
    
  // Splits a heading's rendered content into individual letter spans (while
  // preserving existing tags like <strong>, <em>, <br>, and the accent-word
  // gradient span) so each letter can be hovered independently. Hovering a
  // letter raises it; its immediate left/right neighbors raise half as much.
  function wrapNodeLetters(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var frag = document.createDocumentFragment();
      var text = node.textContent;
      for (var i = 0; i < text.length; i++) {
        if (text[i] === ' ') {
          // Keep real spaces as plain breakable text, not wrapped, so the
          // browser still wraps lines at normal word boundaries. Wrapping
          // every character (spaces included) in its own inline-block span
          // removes the browser's sense of "word" entirely, causing it to
          // break lines in the middle of words instead.
          frag.appendChild(document.createTextNode(' '));
        } else {
          var span = document.createElement('span');
          span.className = 'rich-text__hover-letter';
          span.textContent = text[i];
          frag.appendChild(span);
        }
      }
      return frag;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.tagName === 'BR') {
        return node.cloneNode(true);
      }
      var clone = node.cloneNode(false);
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        var wrapped = wrapNodeLetters(child);
        if (wrapped) clone.appendChild(wrapped);
      });
      return clone;
    }
    return null;
  }

  function attachLetterHoverListeners(letters, lift) {
    letters.forEach(function (letter, idx) {
      letter.addEventListener('mouseenter', function () {
        letter.style.transform = 'translateY(-' + lift + 'px)';
        if (letters[idx - 1]) letters[idx - 1].style.transform = 'translateY(-' + (lift / 2) + 'px)';
        if (letters[idx + 1]) letters[idx + 1].style.transform = 'translateY(-' + (lift / 2) + 'px)';
      });
      letter.addEventListener('mouseleave', function () {
        letter.style.transform = '';
        if (letters[idx - 1]) letters[idx - 1].style.transform = '';
        if (letters[idx + 1]) letters[idx + 1].style.transform = '';
      });
    });
  }

  function applyLetterHoverEffect(container) {
    if (container.dataset.hoverLetterized === 'true') return;
    var lift = parseFloat(container.dataset.hoverLift) || 10;
    var newContent = document.createDocumentFragment();
    Array.prototype.slice.call(container.childNodes).forEach(function (child) {
      var wrapped = wrapNodeLetters(child);
      if (wrapped) newContent.appendChild(wrapped);
    });
    container.innerHTML = '';
    container.appendChild(newContent);
    container.dataset.hoverLetterized = 'true';

    var letters = Array.prototype.slice.call(container.querySelectorAll('.rich-text__hover-letter'));
    attachLetterHoverListeners(letters, lift);
  }

  function initLetterHoverEffects() {
    document.querySelectorAll('.rich-text__letter-hover').forEach(applyLetterHoverEffect);
  }

  // Shrinks a heading's font size until it fits within the allowed number
  // of lines, rather than letting it wrap further. Mobile/narrow screens
  // are allowed one extra line (3) before shrinking kicks in, since short
  // headings often naturally need more vertical room there; tablet and up
  // are capped at 2. Re-measures from the original font size each time
  // (stored once on first run) so widening the window back out correctly
  // restores the full size before re-checking.
  function getMaxLinesForViewport() {
    return window.innerWidth < 750 ? 3 : 2;
  }

  function fitHeadingToTwoLines(heading) {
    if (!heading.dataset.baseFontSize) {
      var initialComputed = window.getComputedStyle(heading);
      heading.dataset.baseFontSize = parseFloat(initialComputed.fontSize);
    }
    var baseFontSize = parseFloat(heading.dataset.baseFontSize);
    var minFontSize = baseFontSize * 0.4;
    var maxLines = getMaxLinesForViewport();

    heading.style.fontSize = baseFontSize + 'px';
    var currentFontSize = baseFontSize;
    var guard = 60;

    while (guard-- > 0) {
      var computed = window.getComputedStyle(heading);
      var lineHeight = parseFloat(computed.lineHeight);
      if (isNaN(lineHeight) || lineHeight <= 0) {
        lineHeight = currentFontSize * 1.2;
      }
      var lines = Math.round(heading.scrollHeight / lineHeight);
      if (lines <= maxLines || currentFontSize <= minFontSize) break;
      currentFontSize -= 1;
      heading.style.fontSize = currentFontSize + 'px';
    }
  }

  function initTwoLineFit() {
    document.querySelectorAll('.rich-text__fit-two-lines').forEach(fitHeadingToTwoLines);
  }

  var twoLineFitResizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(twoLineFitResizeTimer);
    twoLineFitResizeTimer = setTimeout(initTwoLineFit, 100);
  });

  // Curved headings are initially rendered server-side as plain,
  // unformatted characters (see Liquid above). This walks the original
  // formatted heading HTML (held in a hidden .rich-text__path-source
  // element) and rebuilds those characters with real bold/italic
  // preserved per-letter, based on <strong>/<b> and <em>/<i> tags.
  //
  // A shared canvas is used to measure real glyph widths, so letter
  // spacing along the curve reflects each character's actual visual
  // width rather than treating every character as equally wide (which
  // crowds wide letters like M/W and leaves gaps around narrow ones
  // like I/l).
  var measureCanvas = document.createElement('canvas');
  var measureCtx = measureCanvas.getContext('2d');

  function parseCurvedTextChars(outer) {
    var wrapper = outer.parentElement;
    var source = wrapper ? wrapper.querySelector('.rich-text__path-source') : null;
    if (!source) return null;

    var chars = [];
    function walk(node, bold, italic) {
      if (node.nodeType === Node.TEXT_NODE) {
        var text = node.textContent;
        for (var i = 0; i < text.length; i++) {
          chars.push({ char: text[i], bold: bold, italic: italic });
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        var tag = node.tagName.toLowerCase();
        var isBold = bold || tag === 'strong' || tag === 'b';
        var isItalic = italic || tag === 'em' || tag === 'i';
        node.childNodes.forEach(function (child) {
          walk(child, isBold, isItalic);
        });
      }
    }
    source.childNodes.forEach(function (node) {
      walk(node, false, false);
    });
    return chars.length ? chars : null;
  }

  function measureCurvedTextWidths(outer, chars) {
    var wrapper = outer.parentElement;
    var reference = wrapper ? wrapper.querySelector('.rich-text__path-font-reference') : null;
    if (!reference) return null;

    var computed = window.getComputedStyle(reference);
    var normalFont = computed.fontStyle + ' ' + computed.fontWeight + ' ' + computed.fontSize + ' ' + computed.fontFamily;
    var boldFont = computed.fontStyle + ' bold ' + computed.fontSize + ' ' + computed.fontFamily;
    var extraSpacing = parseFloat(outer.dataset.letterSpacing) || 0;

    var widths = chars.map(function (entry) {
      measureCtx.font = entry.bold ? boldFont : normalFont;
      var w = measureCtx.measureText(entry.char).width + extraSpacing;
      return w > 0 ? w : 1;
    });
    var totalWidth = widths.reduce(function (sum, w) { return sum + w; }, 0);
    return { widths: widths, totalWidth: totalWidth };
  }

  function buildCurvedTextFormatting(outer) {
    var inner = outer.querySelector('.rich-text__path-heading-inner');
    var chars = parseCurvedTextChars(outer);
    if (!inner || !chars) return;

    var measured = measureCurvedTextWidths(outer, chars);
    if (!measured) return;

    inner.innerHTML = '';
    var cumulative = 0;
    var letterSpans = [];
    chars.forEach(function (entry, idx) {
      var span = document.createElement('span');
      span.className = 'rich-text__path-char';
      var midpoint = cumulative + measured.widths[idx] / 2;
      cumulative += measured.widths[idx];
      var percent = measured.totalWidth > 0 ? (midpoint / measured.totalWidth) * 100 : 50;
      span.style.offsetDistance = percent + '%';
      if (entry.bold) span.style.fontWeight = 'bold';
      if (entry.italic) span.style.fontStyle = 'italic';
      span.textContent = entry.char === ' ' ? '\u00A0' : entry.char;
      inner.appendChild(span);
      letterSpans.push(span);
    });

    var wrapper = outer.parentElement;
    if (wrapper && wrapper.dataset.hoverEnabled === 'true') {
      var lift = parseFloat(wrapper.dataset.hoverLift) || 10;
      attachLetterHoverListeners(letterSpans, lift);
    }
  }

  function buildAllCurvedText() {
    document.querySelectorAll('.rich-text__path-heading-outer').forEach(buildCurvedTextFormatting);
  }

  // Rather than guessing which CSS variable/selector this theme uses for
  // heading fonts, copy the *actual rendered* font directly from a hidden
  // reference heading (using real heading classes) onto the curved text.
  // Since the custom-font CSS above also targets .rich-text__heading, this
  // automatically picks up the custom font too, with no extra JS needed.
  function syncCurvedTextFont() {
    document.querySelectorAll('.rich-text__path-font-reference').forEach(function (reference) {
      var wrapper = reference.parentElement;
      var outer = wrapper ? wrapper.querySelector('.rich-text__path-heading-outer') : null;
      if (!outer) return;
      var computed = window.getComputedStyle(reference);
      outer.style.setProperty('--path-font-family', computed.fontFamily);
      outer.style.setProperty('--path-font-style', computed.fontStyle);
      outer.style.setProperty('--path-font-weight', computed.fontWeight);
    });
  }

  function updateCurveScale() {
    document.querySelectorAll('.rich-text__path-heading-outer').forEach(function (outer) {
      var wrapper = outer.parentElement;
      if (!wrapper) return;

      var chars = parseCurvedTextChars(outer);
      if (!chars) return;
      var measured = measureCurvedTextWidths(outer, chars);
      if (!measured || measured.totalWidth <= 0) return;

      // Reset any previously-applied width so we measure the wrapper's
      // true available space, not a space we constrained ourselves.
      outer.style.width = '';
      var availableWidth = wrapper.clientWidth;
      var manualSpacing = parseFloat(outer.dataset.letterSpacing) || 0;

      // Prefer the text's natural (unwrapped) width for even letter
      // spacing, but never let it exceed the space actually available --
      // long headings at large font sizes can otherwise overflow the
      // page entirely. This auto-fit only applies when letter spacing is
      // left at the default 0: once someone manually increases spacing,
      // auto-shrinking to compensate would cancel out their adjustment
      // (shrinking letters and gaps by the same amount), so their
      // explicit choice is trusted instead, even if it overflows slightly.
      var targetWidth = measured.totalWidth;
      if (manualSpacing === 0 && availableWidth > 0 && targetWidth > availableWidth) {
        targetWidth = availableWidth;
      }

      var scale = targetWidth / 800;
      outer.style.setProperty('--curve-scale', scale);
      outer.style.width = targetWidth + 'px';
      outer.style.height = (220 * scale) + 'px';
    });
  }

  if (window.ResizeObserver) {
    var curveResizeObserver = new ResizeObserver(updateCurveScale);
    document.querySelectorAll('.rich-text__path-font-reference').forEach(function (reference) {
      curveResizeObserver.observe(reference);
    });
  } else {
    window.addEventListener('resize', updateCurveScale);
  }

  document.addEventListener('DOMContentLoaded', function () {
    buildAllCurvedText();
    syncCurvedTextFont();
    updateCurveScale();
    initLetterHoverEffects();
    initTwoLineFit();
  });
  buildAllCurvedText();
  syncCurvedTextFont();
  updateCurveScale();
  initLetterHoverEffects();
  initTwoLineFit();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      syncCurvedTextFont();
      updateCurveScale();
      initTwoLineFit();
    });
  }

  // The Theme Editor re-renders this section's HTML on every live edit
  // (including toggling bold, changing settings, etc.) without a full
  // page reload -- so re-run everything each time that happens, or the
  // curved text reverts to unstyled/unscaled/unformatted.
  document.addEventListener('shopify:section:load', function () {
    buildAllCurvedText();
    syncCurvedTextFont();
    updateCurveScale();
    initLetterHoverEffects();
    initTwoLineFit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  class CustomStickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', CustomStickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
